module.exports = __webpack_public_path__ + "img/icon__All.64f69991.svg";